module.exports = __webpack_public_path__ + "img/question_circle.0c3e5554.svg";